/**
 * 5g相关
 * */
// 5G套餐
Vue.component(
    'op-meal',
    resolve => require(["../../components/5g/operators"], resolve)
);
// 5G设备
Vue.component(
    'equipment-com',
    resolve => require(["../../components/5g/equipment"], resolve)
);
// 5G地图
Vue.component(
    'map-com',
    resolve => require(["../../components/5g/map"], resolve)
);
// 5G排行
Vue.component(
    'rank-5g',
    resolve => require(["../../components/5g/rank"], resolve)
);

//5g广告弹窗
Vue.component(
    'alert-5g-ad',
    resolve => require(["../../components/5g/AlterAd"], resolve)
);

//5g 网速报告模块
Vue.component(
    'network-report',
    resolve => require(["../../components/5g/networkReport"], resolve)
);




// WEBPACK FOOTER //
// ./resources/js/signCom/module/5g.js